export const LOGOUT = require('Components/Helper/Helpers').logout;
export const SDKLOGOUT = require('Components/Helper/OutsideHelper').logout;
export const COPYRIGHT = require('Components/Copyright/CopyRight').CopyRight;
export const GREENCHECKBOX = require('Components/Inputes/GreenCheckbox');
export const FORCELOGOUT = require('Components/Helper/Helpers').forceLogout;
